export interface PromptTip {
  id: string;
  labelKey: string;
  dontKey: string;
  doKey: string;
}

export const PROMPT_TIPS: PromptTip[] = [
  {
    id: "1",
    labelKey: "chat.promptTips.beSpecific",
    dontKey: "chat.promptTips.tips.beSpecific.dont",
    doKey: "chat.promptTips.tips.beSpecific.do",
  },
  {
    id: "2",
    labelKey: "chat.promptTips.setFormat",
    dontKey: "chat.promptTips.tips.setFormat.dont",
    doKey: "chat.promptTips.tips.setFormat.do",
  },
  {
    id: "3",
    labelKey: "chat.promptTips.setLength",
    dontKey: "chat.promptTips.tips.setLength.dont",
    doKey: "chat.promptTips.tips.setLength.do",
  },
  {
    id: "4",
    labelKey: "chat.promptTips.oneTask",
    dontKey: "chat.promptTips.tips.oneTask.dont",
    doKey: "chat.promptTips.tips.oneTask.do",
  },
  {
    id: "5",
    labelKey: "chat.promptTips.addContext",
    dontKey: "chat.promptTips.tips.addContext.dont",
    doKey: "chat.promptTips.tips.addContext.do",
  },
  {
    id: "6",
    labelKey: "chat.promptTips.stateGoal",
    dontKey: "chat.promptTips.tips.stateGoal.dont",
    doKey: "chat.promptTips.tips.stateGoal.do",
  },
  {
    id: "7",
    labelKey: "chat.promptTips.setAudience",
    dontKey: "chat.promptTips.tips.setAudience.dont",
    doKey: "chat.promptTips.tips.setAudience.do",
  },
  {
    id: "8",
    labelKey: "chat.promptTips.setTone",
    dontKey: "chat.promptTips.tips.setTone.dont",
    doKey: "chat.promptTips.tips.setTone.do",
  },
  {
    id: "9",
    labelKey: "chat.promptTips.useTables",
    dontKey: "chat.promptTips.tips.useTables.dont",
    doKey: "chat.promptTips.tips.useTables.do",
  },
  {
    id: "10",
    labelKey: "chat.promptTips.getTimeline",
    dontKey: "chat.promptTips.tips.getTimeline.dont",
    doKey: "chat.promptTips.tips.getTimeline.do",
  },
  {
    id: "11",
    labelKey: "chat.promptTips.getChecklist",
    dontKey: "chat.promptTips.tips.getChecklist.dont",
    doKey: "chat.promptTips.tips.getChecklist.do",
  },
  {
    id: "12",
    labelKey: "chat.promptTips.getSummary",
    dontKey: "chat.promptTips.tips.getSummary.dont",
    doKey: "chat.promptTips.tips.getSummary.do",
  },
  {
    id: "13",
    labelKey: "chat.promptTips.mapParties",
    dontKey: "chat.promptTips.tips.mapParties.dont",
    doKey: "chat.promptTips.tips.mapParties.do",
  },
  {
    id: "14",
    labelKey: "chat.promptTips.breakItDown",
    dontKey: "chat.promptTips.tips.breakItDown.dont",
    doKey: "chat.promptTips.tips.breakItDown.do",
  },
  {
    id: "15",
    labelKey: "chat.promptTips.setScope",
    dontKey: "chat.promptTips.tips.setScope.dont",
    doKey: "chat.promptTips.tips.setScope.do",
  },
  {
    id: "16",
    labelKey: "chat.promptTips.setTimeframe",
    dontKey: "chat.promptTips.tips.setTimeframe.dont",
    doKey: "chat.promptTips.tips.setTimeframe.do",
  },
  {
    id: "17",
    labelKey: "chat.promptTips.addThreshold",
    dontKey: "chat.promptTips.tips.addThreshold.dont",
    doKey: "chat.promptTips.tips.addThreshold.do",
  },
  {
    id: "18",
    labelKey: "chat.promptTips.prioritize",
    dontKey: "chat.promptTips.tips.prioritize.dont",
    doKey: "chat.promptTips.tips.prioritize.do",
  },
  {
    id: "19",
    labelKey: "chat.promptTips.singleAnswer",
    dontKey: "chat.promptTips.tips.singleAnswer.dont",
    doKey: "chat.promptTips.tips.singleAnswer.do",
  },
  {
    id: "20",
    labelKey: "chat.promptTips.filterType",
    dontKey: "chat.promptTips.tips.filterType.dont",
    doKey: "chat.promptTips.tips.filterType.do",
  },
  {
    id: "21",
    labelKey: "chat.promptTips.askMissing",
    dontKey: "chat.promptTips.tips.askMissing.dont",
    doKey: "chat.promptTips.tips.askMissing.do",
  },
  {
    id: "22",
    labelKey: "chat.promptTips.findGaps",
    dontKey: "chat.promptTips.tips.findGaps.dont",
    doKey: "chat.promptTips.tips.findGaps.do",
  },
  {
    id: "23",
    labelKey: "chat.promptTips.citePages",
    dontKey: "chat.promptTips.tips.citePages.dont",
    doKey: "chat.promptTips.tips.citePages.do",
  },
  {
    id: "24",
    labelKey: "chat.promptTips.quoteText",
    dontKey: "chat.promptTips.tips.quoteText.dont",
    doKey: "chat.promptTips.tips.quoteText.do",
  },
  {
    id: "25",
    labelKey: "chat.promptTips.findSupport",
    dontKey: "chat.promptTips.tips.findSupport.dont",
    doKey: "chat.promptTips.tips.findSupport.do",
  },
  {
    id: "26",
    labelKey: "chat.promptTips.traceCausation",
    dontKey: "chat.promptTips.tips.traceCausation.dont",
    doKey: "chat.promptTips.tips.traceCausation.do",
  },
  {
    id: "27",
    labelKey: "chat.promptTips.findConflicts",
    dontKey: "chat.promptTips.tips.findConflicts.dont",
    doKey: "chat.promptTips.tips.findConflicts.do",
  },
  {
    id: "28",
    labelKey: "chat.promptTips.compareVersions",
    dontKey: "chat.promptTips.tips.compareVersions.dont",
    doKey: "chat.promptTips.tips.compareVersions.do",
  },
  {
    id: "29",
    labelKey: "chat.promptTips.checkStory",
    dontKey: "chat.promptTips.tips.checkStory.dont",
    doKey: "chat.promptTips.tips.checkStory.do",
  },
  {
    id: "30",
    labelKey: "chat.promptTips.matchClaims",
    dontKey: "chat.promptTips.tips.matchClaims.dont",
    doKey: "chat.promptTips.tips.matchClaims.do",
  },
  {
    id: "31",
    labelKey: "chat.promptTips.crossReference",
    dontKey: "chat.promptTips.tips.crossReference.dont",
    doKey: "chat.promptTips.tips.crossReference.do",
  },
  {
    id: "32",
    labelKey: "chat.promptTips.findWeakness",
    dontKey: "chat.promptTips.tips.findWeakness.dont",
    doKey: "chat.promptTips.tips.findWeakness.do",
  },
  {
    id: "33",
    labelKey: "chat.promptTips.spotIssues",
    dontKey: "chat.promptTips.tips.spotIssues.dont",
    doKey: "chat.promptTips.tips.spotIssues.do",
  },
  {
    id: "34",
    labelKey: "chat.promptTips.flagMissing",
    dontKey: "chat.promptTips.tips.flagMissing.dont",
    doKey: "chat.promptTips.tips.flagMissing.do",
  },
  {
    id: "35",
    labelKey: "chat.promptTips.checkCompliance",
    dontKey: "chat.promptTips.tips.checkCompliance.dont",
    doKey: "chat.promptTips.tips.checkCompliance.do",
  },
  {
    id: "36",
    labelKey: "chat.promptTips.testCredibility",
    dontKey: "chat.promptTips.tips.testCredibility.dont",
    doKey: "chat.promptTips.tips.testCredibility.do",
  },
  {
    id: "37",
    labelKey: "chat.promptTips.calculate",
    dontKey: "chat.promptTips.tips.calculate.dont",
    doKey: "chat.promptTips.tips.calculate.do",
  },
  {
    id: "38",
    labelKey: "chat.promptTips.estimate",
    dontKey: "chat.promptTips.tips.estimate.dont",
    doKey: "chat.promptTips.tips.estimate.do",
  },
  {
    id: "39",
    labelKey: "chat.promptTips.showMath",
    dontKey: "chat.promptTips.tips.showMath.dont",
    doKey: "chat.promptTips.tips.showMath.do",
  },
  {
    id: "40",
    labelKey: "chat.promptTips.compareValue",
    dontKey: "chat.promptTips.tips.compareValue.dont",
    doKey: "chat.promptTips.tips.compareValue.do",
  },
  {
    id: "41",
    labelKey: "chat.promptTips.buildArgument",
    dontKey: "chat.promptTips.tips.buildArgument.dont",
    doKey: "chat.promptTips.tips.buildArgument.do",
  },
  {
    id: "42",
    labelKey: "chat.promptTips.draftLanguage",
    dontKey: "chat.promptTips.tips.draftLanguage.dont",
    doKey: "chat.promptTips.tips.draftLanguage.do",
  },
  {
    id: "43",
    labelKey: "chat.promptTips.setCriteria",
    dontKey: "chat.promptTips.tips.setCriteria.dont",
    doKey: "chat.promptTips.tips.setCriteria.do",
  },
  {
    id: "44",
    labelKey: "chat.promptTips.yesOrNo",
    dontKey: "chat.promptTips.tips.yesOrNo.dont",
    doKey: "chat.promptTips.tips.yesOrNo.do",
  },
  {
    id: "45",
    labelKey: "chat.promptTips.categorize",
    dontKey: "chat.promptTips.tips.categorize.dont",
    doKey: "chat.promptTips.tips.categorize.do",
  },
  {
    id: "46",
    labelKey: "chat.promptTips.extractData",
    dontKey: "chat.promptTips.tips.extractData.dont",
    doKey: "chat.promptTips.tips.extractData.do",
  },
  {
    id: "47",
    labelKey: "chat.promptTips.findDates",
    dontKey: "chat.promptTips.tips.findDates.dont",
    doKey: "chat.promptTips.tips.findDates.do",
  },
  {
    id: "48",
    labelKey: "chat.promptTips.nextSteps",
    dontKey: "chat.promptTips.tips.nextSteps.dont",
    doKey: "chat.promptTips.tips.nextSteps.do",
  },
  {
    id: "49",
    labelKey: "chat.promptTips.revise",
    dontKey: "chat.promptTips.tips.revise.dont",
    doKey: "chat.promptTips.tips.revise.do",
  },
  {
    id: "50",
    labelKey: "chat.promptTips.askMe",
    dontKey: "chat.promptTips.tips.askMe.dont",
    doKey: "chat.promptTips.tips.askMe.do",
  },
];

const TIPS_COUNT = 3;

export function getRandomTips(count: number = TIPS_COUNT): PromptTip[] {
  const shuffled = [...PROMPT_TIPS].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
}
